/* eslint-disable react/display-name */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';

import {
  SearchFacetType,
  SuggestionItemProp,
  DetailsControlProps
} from '../type';
import LabelFacetDetails from '../LabelFacetDetails';
import LabelOptionItem from '../OptionItem';
import { programTag } from './tag';
import makeCriteriaProvider from './makeCriteriaProvider';
import { useProgramLabelSearch } from './hooks/useProgramLabelSearch';
import ProgramIcon from './ProgramIcon';

const icon = <ProgramIcon />;
const noProgramsMessage = <FormattedMessage id="search.facets.noProgram" />;

export const getDetailsControl = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingInitialDopDownValue?: (label: any, setSelected: any) => void
): React.FC<DetailsControlProps> => ({
  selected,
  setSelected
}: DetailsControlProps) => {
  const { options, loading, searchHandler, hasMore } = useProgramLabelSearch();
  return (
    <LabelFacetDetails
      selected={selected}
      setSelected={setSelected}
      options={options}
      loading={loading}
      searchHandler={searchHandler}
      label={label}
      icon={icon}
      noOptionsText={noProgramsMessage}
      hasMore={hasMore}
      onDropdownValueChange={onDropdownValueChange}
      isDisable={isDisable}
      settingInitialDopDownValue={settingInitialDopDownValue}
    />
  );
};

const SuggestionItem: React.FC<SuggestionItemProp> = ({
  option
}: SuggestionItemProp) => (
  <LabelOptionItem testId={option.id} value={option.label} icon={icon} />
);

export const getProgramFacet = (
  label: TimesheetLabel,
  onDropdownValueChange?: (mappedValue: any, label: any) => void,
  isDisable?: (label: any) => boolean,
  settingInitialDopDownValue?: (label: any, setSelected: any) => void
): SearchFacetType => ({
  makeCriteriaProvider: makeCriteriaProvider(label),
  tag: programTag,
  DetailsControl: getDetailsControl(
    label,
    onDropdownValueChange,
    isDisable,
    settingInitialDopDownValue
  ),
  SuggestionItem: SuggestionItem
});

export default getProgramFacet;
